// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"7873f2c8","401":"e746cb8a","453":"7eecaf1e","455":"5bc1230e","977":"2325f8e0"}[chunkId] + ".chunk.js";
};